import ShareOfShelf from "./ShareOfShelf";
export default ShareOfShelf;
